import { render, staticRenderFns } from "./cfbb.vue?vue&type=template&id=0323b01c&scoped=true&"
import script from "./cfbb.vue?vue&type=script&lang=js&"
export * from "./cfbb.vue?vue&type=script&lang=js&"
import style0 from "./cfbb.vue?vue&type=style&index=0&id=0323b01c&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0323b01c",
  null
  
)

export default component.exports